//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
//@end

//@import components
import AlertComponent from 'app_components/commons/alert'
import GraphcardCommon from 'app_components/commons/graphcard'
import ClassesTaughtSkeleton from './classesTaughtSkeleton'
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../classesTaughtModule.scss'

// @ADD Component types
interface IClassesTaughtModuleLayoutProps {
  currentYear: number,
  reportData: any
  chartOptions: any
  status: 'loading' | 'error' | null
}

const ClassesTaughtModuleLayout: React.FC<IClassesTaughtModuleLayoutProps> = (props) => {

  const { t } = useTranslation()

  return(
    <div className='classes_taught_module-component'>
      <div className="title-graph">
        {`${t(`modules.classes_taught_module.title`)} ${props.currentYear}`}
      </div>
      <div className="graph">
        {props.status === 'loading' ? (
          <ClassesTaughtSkeleton />
        ) : (
          <>
            {props.reportData ? (
              <GraphcardCommon
                type='bars'
                data={props.reportData}
                options={props.chartOptions}
              />
            ): (
              <AlertComponent
                type='warning'
                title={t('modules.classes_taught_module.no_data')}
              />
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default ClassesTaughtModuleLayout
